<template>
  <div class="examine-topbar">
    <div class="examine-list-topbar">
      <div class="examine-search">
        <search :placeholder="placeholder" @search="search" />
      </div>
    </div>
    <div class="topbar-tabs">
      <div
        class="tab-item"
        :class="currentCourseItem == index ? 'current-item' : ''"
        v-for="(item, index) in statusList"
        :key="index"
        @click="changeCurrentTabItem(index)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";

export default {
  components: {
    search,
  },
  data() {
    return {
      currentCourseItem: 0,
      startTimeShow: "",
      endTimeShow: "",
      startTime: "",
      endTime: "",
      startTimestamp: 0,
      endTimestamp: 0,
      selectList: [],
      examineType: "",
      placeholder: "请输入申请人姓名",
      searchContent: "",
    };
  },
  props: {
    statusList: {
      type: Array,
      require: true,
    },
  },
  created() {
    // console.log(this.statusList);
  },
  methods: {
    // 切换状态
    changeCurrentTabItem(tabsIndex) {
      // console.log(tabsIndex);
      this.currentCourseItem = tabsIndex;
      // console.log(this.currentCourseItem);
      // 下标传值
      this.$emit("currentContentIndex", this.currentCourseItem);
    },
    // 搜索
    search(e) {
      // console.log(e);
      // 传搜索词给父
      this.$emit("searchText",e)
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./examine-topbar.scss";
</style>